import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';

function FacilityOrderTemplateNewFlowInsuranceProductModalTemplate({ facilityOrderTemplateNewFlowInsuranceProductModalStore }) {
    const {
        facilityOrderTemplate
    } = facilityOrderTemplateNewFlowInsuranceProductModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Product List</h3>
            </div>

            <div className="modal__body">
                <h3 className='type--sml u-mar--bottom--med'> Template Category: <b>{facilityOrderTemplate.itemCategory.name}</b></h3>
                <div className="table--tertiary__wrapper u-mar--bottom--sml">
                    <table className="table table--tertiary">
                        <colgroup>
                            <col width="250*" />
                            <col width="200" />
                            <col width="200" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>ITEM NAME</th>
                                <th>ITEM ID</th>
                                <th>PROCEDURE CODE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {facilityOrderTemplate.facilityOrderTemplateItems.map((item) => {
                                return (
                                    <tr key={item.id}>
                                        <td>
                                            {item.product && item.product.description}
                                        </td>
                                        <td>
                                            {item.product && item.product.itemId}
                                        </td>
                                        <td>
                                            {item.product && item.product.procedureCode}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='modal__footer'>
            </div>
        </section>
    )
}

FacilityOrderTemplateNewFlowInsuranceProductModalTemplate.propTypes = {
    facilityOrderTemplateNewFlowInsuranceProductModalStore: PropTypes.object,
};

export default defaultTemplate(FacilityOrderTemplateNewFlowInsuranceProductModalTemplate);
